
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","fill-rule":"evenodd","d":"M21.85 20.152l-.7.7a.5.5 0 01-.71 0l-4-3.999c-.11-.11-.211-.23-.3-.36l-.75-1a6.994 6.994 0 01-4.39 1.51 6.894 6.894 0 01-3-.69.485.485 0 01-.3-.31.513.513 0 01.14-.44l.76-.759a.51.51 0 01.54-.11 5.002 5.002 0 005.745-1.493 4.996 4.996 0 00.27-5.927A5.001 5.001 0 006 10.005h1.75a.5.5 0 01.35.85l-2.74 2.75a.512.512 0 01-.71 0l-2.75-2.75a.499.499 0 01.36-.849H4a7 7 0 0112.808-3.914 6.995 6.995 0 01-.378 8.322l1 .69c.156.1.3.217.43.35l4 3.999a.5.5 0 01-.01.7z"}})])
          )
        }
      }
    